'use client'

import { ChakraProvider } from '@chakra-ui/react'
import AlertProvider from '@/src/components/Common/CustomAlertDialog'
import { ToastProvider } from '@/src/providers/ToastProvider'
import AdvKeyProvider from '@/src/providers/AdvKeyProvider'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ChakraProvider>
      <AlertProvider>
        <AdvKeyProvider>
          <ToastProvider>
            {children}
          </ToastProvider>
        </AdvKeyProvider>
      </AlertProvider>
    </ChakraProvider>
  )
}